import {
  type LucideIcon,
  File,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo
} from 'lucide-react'

export type FileIconInfo = {
  Icon: LucideIcon
  className: string
}

/** mirrors standard file-type color conventions: pdf red, image purple,
 * doc blue, sheet green, video orange, anything else gray.
 */
export function getFileIcon(contentType: string): FileIconInfo {
  if (contentType.startsWith('image/')) {
    return { Icon: FileImage, className: 'text-purple-600' }
  }
  if (contentType.startsWith('video/')) {
    return { Icon: FileVideo, className: 'text-orange-600' }
  }
  if (contentType === 'application/pdf') {
    return { Icon: FileText, className: 'text-red-600' }
  }
  if (
    contentType === 'application/msword' ||
    contentType ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return { Icon: FileText, className: 'text-blue-600' }
  }
  if (
    contentType === 'application/vnd.ms-excel' ||
    contentType ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    contentType === 'text/csv'
  ) {
    return { Icon: FileSpreadsheet, className: 'text-emerald-600' }
  }
  return { Icon: File, className: 'text-ink-muted' }
}
